// Auto-generated from Contentful - DO NOT EDIT
// Generated at: 2026-02-04T02:14:54.505Z

const ocSupport = {
  id: `OC`,
  text: `Business Coordinators acts as your primary support for technical, billing, and platform guidance, working under your Business Manager to ensure a seamless experience. They are instrumental in facilitating smooth operations and effective HR service delivery, making every interaction with Bambee straightforward and productive.`,
  notes: `Business Coordinator`,
  list: [
    `Platform Support`,
    `Payroll Onboarding`,
    `Billing Questions`,
    `Administrative Account Requests`,
  ],
} as const;

export default ocSupport;
